import { useEffect, useState } from "react";
import { useAppDispatch } from "../../../../../../hooks/reduxHooks";
import { addImage } from "../../../../../store/slices/viewSlice";

const UploadedImage = ({ imageList, onSelectImage, onDeleteImage }: any) => {
  const [imgList, setImgList] = useState(imageList);
  const dispatch = useAppDispatch();
  useEffect(() => {
    setImgList(imageList);
  }, [imageList]);
  const deleteImage = (id: number) => {
    let list = [];
    let localStorageImage = localStorage.getItem("user-uploaded-image");
    if (localStorageImage && localStorageImage !== "") {
      list = JSON.parse(localStorage.getItem("user-uploaded-image") as any);
    }
    const indexToRemove = list.findIndex((obj: any) => obj.id === id);
    if (indexToRemove !== -1) {
      list.splice(indexToRemove, 1);
    } else {
      console.log("Object not found in the array.");
    }
    localStorage.setItem("user-uploaded-image", JSON.stringify(list));
    setImgList(list);
  };

  return (
    <>
      {imgList && imgList.length ? (
        <div className="my-5">
          <div className="font-bold text-lg">Your recent uploads</div>
          <div className="flex flex-wrap gap-4 my-4">
            {imgList &&
              imgList.length &&
              imgList.map((img: any) => {
                if (!img.imageUrl) return;
                return (
                  <div className="relative cursor-pointer w-[80px]">
                    <button
                      className="absolute -top-[8px] -right-[8px] p-[3px] border border-solid border-lightgrey bg-white rounded-full"
                      onClick={() => {
                        deleteImage(img.id);
                      }}
                    >
                      <svg
                        width="12"
                        height="13"
                        viewBox="0 0 12 13"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M11.3955 11.1593C11.3955 11.6331 11.228 12.0375 10.8929 12.3726C10.5578 12.7077 10.1591 12.8752 9.69695 12.8752C9.16543 12.8752 8.74367 12.6903 8.4317 12.3206L5.84919 9.23546L3.26669 12.3206C2.95471 12.6903 2.53296 12.8752 2.00144 12.8752C1.53924 12.8752 1.1406 12.7077 0.805513 12.3726C0.470423 12.0375 0.302878 11.6331 0.302878 11.1593C0.302878 10.7318 0.441536 10.3621 0.718852 10.0501L3.63067 6.79161L0.926838 3.81047C0.649523 3.49849 0.510865 3.11718 0.510865 2.66654C0.510865 2.19279 0.67841 1.79415 1.0135 1.47062C1.36014 1.13553 1.76456 0.967983 2.22676 0.967983C2.76983 0.967983 3.21469 1.18752 3.56134 1.62661L5.84919 4.43443L8.13705 1.62661C8.48369 1.18752 8.92855 0.967983 9.47163 0.967983C9.93382 0.967983 10.3325 1.13553 10.6676 1.47062C11.0142 1.79415 11.1875 2.19279 11.1875 2.66654C11.1875 3.12873 11.1009 3.44649 10.9275 3.61981L8.06772 6.79161L10.9795 10.0501C11.2568 10.3621 11.3955 10.7318 11.3955 11.1593Z"
                          fill="#CCCFD6"
                        />
                      </svg>
                    </button>
                    <label
                      onClick={() => {
                        dispatch(
                          addImage({
                            img: img.imageUrl,
                            width: img.width,
                            height: img.height,
                          })
                        );
                      }}
                      htmlFor="upload1"
                      className="cursor-pointer"
                    >
                      <img src={img.imageUrl} alt="" />
                    </label>
                  </div>
                );
              })}
          </div>
        </div>
      ) : (
        ""
      )}
    </>
  );
};

export default UploadedImage;
